import type { MenuItem } from "./types";

export const renameMenuItem: MenuItem = {
    id: "rename",
    iconName: "edit-icon",
    text: { key: "si.options-menu.list.rename" },
};

export const deleteMenuItem: MenuItem = {
    id: "delete",
    iconName: "delete",
    text: { key: "si.options-menu.list.delete" },
};

export const getModifyMenuItem = (item: MenuItem, updatedFields: Partial<MenuItem>) => {
    return {
        ...item,
        ...updatedFields,
    };
};

export const OPTION_MENU = [
    getModifyMenuItem(renameMenuItem, { text: { key: "si.options-menu.saved-search.rename" } }),
    getModifyMenuItem(deleteMenuItem, { text: { key: "si.options-menu.saved-search.delete" } }),
];
